import React from "react";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle
} from "@material-ui/core";
import IntlMessages from "util/IntlMessages";
import CardFileUpload from "components/Form/CardFileUpload";
import { postAdverseReactionFile } from "api/apiList";
import { keepOriginalFileName } from "app/routes/psp/services/userService";

const MediaModal = ({ rowObj, open, handleRequestClose, loadTable }) => {
  return (
    <div>
      <Dialog
        fullWidth={true}
        maxWidth="md"
        open={open}
        disableBackdropClick={true}
        onClose={handleRequestClose}
      >
        <DialogTitle>
          <IntlMessages id={"core.multimedia"} />
        </DialogTitle>
        <DialogContent>
          <div>
            <CardFileUpload
              file={rowObj?.filePath}
              setFile={() => {
                if (loadTable) {
                  loadTable();
                }
                handleRequestClose();
              }}
              actionApi={postAdverseReactionFile}
              actionApiInfo={{ id: rowObj?.id }}
              sendOriginalName={keepOriginalFileName()}
              disabled={false}
            />
          </div>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleRequestClose} color="secondary">
            <IntlMessages id="core.close" />
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default MediaModal;
